import $RefParser from "@apidevtools/json-schema-ref-parser";

export async function safeSchemaDereferencer(schema: any, { maxDepth = 10 }) {
  const object_schema = await $RefParser.dereference(schema);
  return JSON.parse(JSON.stringify(object_schema, getCircularReplacer(maxDepth)));
}

export function getCircularReplacer(maxDepth = 10) {
  const stack: object[] = [];
  let depth = 0;

  return function (this: object, _key: string, value: unknown) {
    if (typeof value !== "object" || value === null) {
      return value;
    }

    // Pop ancestors until we find the current parent
    while (stack.length > 0 && stack[stack.length - 1] !== this) {
      stack.pop();
      depth--;
    }

    // Check for circular reference in current path
    if (stack.includes(value)) {
      return {
        type: "string",
      };
    }

    // Check depth limit
    if (depth >= maxDepth) {
      return {
        type: "string",
      };
    }

    stack.push(value);
    depth++;
    return value;
  };
}
